angular.module("siter.io").directive "resize", ["$timeout", "$window", ($timeout, $window) ->
  restrict: "A"
  scope: true
  link: (scope, element, attrs) ->
    $timeout ->
      scope.type = attrs.resize
      if attrs.resizeDependence
        scope.dependence = attrs.resizeDependence.split(",")
      if attrs.resizeAttr
        scope.attr = attrs.resizeAttr
      else
        scope.attr = scope.type
      if attrs.resizeMargin
        scope.margin = attrs.resizeMargin
      else
        scope.margin = 0


      scope.initializeWindowSize = ->
        if scope.type is 'width'
          if $window.innerWidth > 980 && $window.innerWidth < 1120
            inner = $window.innerWidth
          if $window.innerWidth > 1120
            inner = 1120
          if $window.innerWidth < 980
            inner = 980
        if scope.type is 'height'
          inner = $window.innerHeight

        i = 0
        dependencesSize = 0
        if scope.dependence
          if scope.type is 'width'
            while i < scope.dependence.length
              dependencesSize += angular.element(scope.dependence[i]).outerWidth(true)
              i++
          if scope.type is 'height'
            while i < scope.dependence.length
              dependencesSize += angular.element(scope.dependence[i]).outerHeight(true)
              i++
        scope.elSize = inner - dependencesSize - scope.margin
        angular.element(element).css(scope.attr, scope.elSize)
        return


      scope.initializeWindowSize()
      angular.element($window).bind "resize", ->
        scope.initializeWindowSize()
        scope.$apply() if !scope.$$phase

]



// WEBPACK FOOTER //
// ./src/app/common/directives/resize.coffee